import React from "react"
import { Navigate, Outlet } from "react-router-dom"

import AuthArea from "@/pages/panel/auth_area"
import RedirectToReservations from "@/pages/panel/redirect_to_reservations"
import ReservationsAll from "@/pages/panel/reservations/all"
import ReservationsList from "@/pages/panel/reservations/list"
import ReservationsVenuePlan from "@/pages/panel/reservations/venue_plan"
import SettingsWrapper from "@/pages/panel/settings"
import ProfileOverview from "@/pages/panel/settings/profile"
import ChangePassword from "@/pages/panel/settings/profile/change_password"
import UserList from "@/pages/panel/settings/users/list"
import RolesPermissions from "@/pages/panel/settings/users/roles"
import AddVenue from "@/pages/panel/settings/venues/add"
import OpeningHours from "@/pages/panel/settings/venues/opening_hours"
import ReservationRules from "@/pages/panel/settings/venues/reservation_rules"
import VenueTabbio from "@/pages/panel/settings/venues/tabbio"
import VenueInformationPage from "@/pages/panel/settings/venues/venue_information"
import VenueLayout from "@/pages/panel/settings/venues/venue_layout"

import ErrorPage from "./pages/not_found"
import OAuthSignup from "./pages/oauth_signup"
import ActivityLog from "./pages/panel/activity_log"
import Clients from "./pages/panel/clients"
import Reservations from "./pages/panel/reservations"
import RedirectLegacyPublicReserve from "./pages/public/redirect_legacy_public_reserve"
import PublicReservation from "./pages/public/reservation"
import PublicVenue from "./pages/public/venue"
import ResetPassword from "./pages/reset_password"
import SignIn from "./pages/sign_in"
import SignUp from "./pages/sign_up"

export const routes = [
  {
    path: "/",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Navigate to="panel" replace />,
      },
      {
        path: "sign_in",
        element: <SignIn />,
      },
      {
        path: "sign_in/forgot_password",
        element: <SignIn />,
      },
      {
        path: "sign_up",
        element: <SignUp />,
      },
      {
        path: "oauth-signup",
        element: <OAuthSignup />,
      },
      {
        path: "reset_password/:token",
        element: <ResetPassword />,
      },
      {
        path: "v/:slug",
        element: <PublicVenue />,
      },
      {
        path: "v/:slug/reserve",
        element: <RedirectLegacyPublicReserve />,
      },
      {
        path: "r/:reservationId",
        element: <PublicReservation />,
      },
      {
        path: "r/:reservationId/cancel",
        element: <PublicReservation />,
      },
      {
        path: "panel/:slug?",
        element: <AuthArea />,
        children: [
          {
            index: true,
            element: <RedirectToReservations />,
          },
          {
            path: "reservations/:reservationId?/edit?",
            element: <Reservations />,
          },
          {
            path: "reservations/list/:filter?",
            element: <ReservationsList />,
          },
          {
            path: "reservations/all/:filter?",
            element: <ReservationsAll />,
          },
          {
            path: "reservations/venue_plan",
            element: <ReservationsVenuePlan />,
          },
          {
            path: "activity_log",
            element: <ActivityLog />,
          },
          {
            path: "clients/:customerContactId?",
            element: <Clients />,
          },
          {
            path: "settings",
            element: <SettingsWrapper />,
            children: [
              {
                index: true,
                element: <Navigate to="profile/overview" replace />,
              },
              {
                path: "profile/overview",
                element: <ProfileOverview />,
              },
              {
                path: "profile/change_password",
                element: <ChangePassword />,
              },
              {
                path: "users/list",
                element: <UserList />,
              },
              {
                path: "users/roles",
                element: <RolesPermissions />,
              },
              {
                path: "venues/add",
                element: <AddVenue />,
              },
              {
                path: "venues/:venueSlug/tabbio",
                element: <VenueTabbio />,
              },
              {
                path: "venues/:venueSlug/venue_information",
                element: <VenueInformationPage />,
              },
              {
                path: "venues/:venueSlug/reservation_rules",
                element: <ReservationRules />,
              },
              {
                path: "venues/:venueSlug/opening_hours",
                element: <OpeningHours />,
              },
              {
                path: "venues/:venueSlug/venue_layout",
                element: <VenueLayout />,
              },
            ],
          },
        ],
      },
      { path: "*", element: <ErrorPage /> },
    ],
  },
]
